import { Download, Loader2 } from 'lucide-react';
import { Button } from '@/shared/components/ui/button';
import { cn } from '@/shared/utils/cn';

type ExportButtonProps = {
  onClick: () => void;
  label?: string;
  isLoading?: boolean;
  disabled?: boolean;
  className?: string;
};

export const ExportButton = ({
  onClick,
  label = 'Download CSV',
  isLoading = false,
  disabled = false,
  className,
}: ExportButtonProps) => {
  return (
    <Button
      variant="outline"
      size="sm"
      onClick={onClick}
      disabled={isLoading || disabled}
      className={cn('gap-2', className)}
    >
      {isLoading ? (
        <>
          <Loader2 className="h-4 w-4 animate-spin" />
          Exporting...
        </>
      ) : (
        <>
          <Download className="h-4 w-4" />
          {label}
        </>
      )}
    </Button>
  );
};
